import { configureStore } from "@reduxjs/toolkit";
import jobsReducer from "../features/Job/jobSlice";
import jobSortReducer from "../features/JobSorting/JobSortingSlice";

export const store = configureStore({
  reducer: {
    Jobs: jobsReducer,
    JobSort: jobSortReducer,
  },
});
